import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RestApiModel } from '../../../shared/model/rest-api.model';
import { SortUtils } from '../../../shared/utils/sort.utils';
import { MakeModel } from '../model/make.model';

@Injectable()
export class MakeService {
  private readonly makesURL = RestApiModel.PROXY_API_URL + '/makes';
  private readonly createMakeURL = `${RestApiModel.PROXY_API_URL}/make`;
  private readonly updateMakeURL = `${RestApiModel.PROXY_API_URL}/make/{1}`;
  private readonly makeURL = `${
    RestApiModel.PROXY_API_URL
  }/assetService/make/{1}`;

  constructor(private http: HttpClient) {
    // gold.
  }

  /**
   * GET - List of makes
   */
  getMakes(showInactive: boolean): Observable<Array<MakeModel>> {
    return this.http
      .get(`${this.makesURL}?showInactive=${showInactive}`)
      .map((res: any) => {
        if (res.results) {
          return SortUtils.sortCollection(res.results, 'name');
        } else {
          return [];
        }
      })
      .catch(this.handleError);
  }

  /**
   * GET - List of makes
   */
  getMake(id: number): Observable<MakeModel> {
    return this.http
      .get(this.makeURL.replace('{1}', id.toString()))
      .map((res: any) => {
        return res ? res : null;
      })
      .catch(this.handleError);
  }

  /**
   * POST - Create a new make.
   * @param {MakeModel} makeModel
   * @returns {Observable<any>}
   */
  createMake(makeModel: MakeModel): Observable<any> {
    return this.http
      .post(this.createMakeURL, makeModel as any)
      .map((res: any) => res)
      .catch(this.handleError);
  }

  /**
   * PUT - Create a new make.
   * @param {MakeModel} makeModel
   * @returns {Observable<any>}
   */
  updateMake(makeModel: MakeModel): Observable<any> {
    return this.http
      .put(
        this.updateMakeURL.replace('{1}', makeModel.id.toString()),
        makeModel as any
      )
      .map((res: any) => res)
      .catch(this.handleError);
  }

  /**
   * Resolves the given error as JSON object
   */
  private handleError(error: any) {
    console.log(error);
    return error;
  }
}
